import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material'
import Logo from '../../logo.jpeg'
import { Column, Row } from '../Common/CommonComponents'
import { Facebook, Instagram } from '@mui/icons-material'

const height = '40px'
const width = '60px'

const Container = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-around',
  backgroundColor: theme.palette.grey[50],
  borderTop: `1px solid ${theme.palette.grey[300]}`,
  padding: '24px 36px',
}))

const IconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '12px',
  alignItems: 'center',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.shade?.p12,
  padding: '6px',
  cursor: 'pointer',
}))

const ColumnContainerHideSmall = styled(Column)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
  gap: '12px',
  display: 'flex',
  flexDirection: 'column',
  flex: '1',
  akulignItems: 'center',
}))

const RowContainerHideSmall = styled(Column)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
  gap: '12px',
  display: 'flex',
  flexDirection: 'row',
  flex: '1',
}))

const openInNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
}

const onNavInstagram = () => openInNewTab('https://www.instagram.com/all_around_pool_cleaning')

const onNavFacebook = () => openInNewTab('https://www.facebook.com/PoolCleaningAndMaintenance/')

const Footer = () => (
    <Container>
        <Column gap="4px" flex="1" paddingRight="8px">
            <Row alignItems="center">
                <img src={Logo} height={height} width={width} alt="card" />
                <Typography variant="subtitle1" >
                    All Around Pool Cleaning
                </Typography>
            </Row>
            <Typography variant="body2" >
             Dedicated to the art and science of aquatic maintenance. Your oasis, our obsession
            </Typography>
        </Column>
        <RowContainerHideSmall>
            <ColumnContainerHideSmall>
                <Typography variant="subtitle1" >
                    Services
                </Typography>
                <Typography variant="body2" >
                    Recurring Cleaning
                </Typography>
                <Typography variant="body2" >
                    Equipment
                </Typography>
                <Typography variant="body2" >
                    Chemical Balance
                </Typography>
            </ColumnContainerHideSmall>
            <ColumnContainerHideSmall>
                <Typography variant="subtitle1" >
                    Company
                </Typography>
                <Typography variant="body2" >
                    30 Years Experience
                </Typography>
                <Typography variant="body2" >
                    Family Owned
                </Typography>
                <Typography variant="body2" >
                    Sydney
                </Typography>
            </ColumnContainerHideSmall>
        </RowContainerHideSmall>
        <Column gap="4px" flex=".5" alignItems="center">
          <Typography variant="subtitle1" >
            CONNECT
          </Typography>
          <Row gap="12px">
            <IconContainer onClick={onNavFacebook}>
              <Facebook />
            </IconContainer>
            <IconContainer onClick={onNavInstagram}>
              <Instagram />
            </IconContainer>
          </Row>
        </Column>
    </Container>
)

export default Footer